export default {
  INIT: 'SETTING/INIT',
  UPDATE_DATA: 'SETTING/UPDATE_DATA',
}
